import React from 'react';

const RootsPig = (props) => {
  const { radius, cells } = props;

  const base = cells[1].background;

  return (

    <svg width={`${radius * 1.83}px`} height={`${radius * 0.75}px`} x={`-${radius *.92}px`} y={`-${radius * 1.35}px`} viewBox="0 0 183 75" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="Canvas" transform="translate(-8 -0)">
        <g id="Vector">
          <use xlinkHref="#path0_fill" transform="translate(8.71235 0.466762)" fill={base} />
          <use xlinkHref="#path1_fill" transform="translate(8.71235 0.466762)" fill={base} />
          <use xlinkHref="#path2_fill" transform="translate(8.71235 0.466762)" fill={base} />
        </g>
      </g>
      <defs>
        <path id="path0_fill" fillRule="evenodd" d="M 92.3571 35.1762C 92.3571 35.1762 91.9352 29.5406 92.357 26.2303C 98.2642 29.3717 106.474 28.7434 110.381 24.4788C 114.479 19.8181 112.896 11.3442 106.868 8.04713C 100.049 4.36803 94.5918 7.59265 90.268 12.9252C 89.6365 10.1807 89.7826 6.83508 90.7411 2.61249C 91.213 0.00960482 86.6998 -1.97157 84.8935 3.40383C 83.6591 7.59101 83.5226 14.1621 86.1997 19.5523C 82.1464 27.1625 80.1441 35.1762 80.1441 35.1762L 92.3571 35.1762ZM 102.404 14.4831C 98.0964 13.0891 95.6586 15.72 94.0984 19.1644C 96.044 20.3954 98.3358 21.1102 100.818 21.4288C 106.335 22.137 106.987 15.9126 102.404 14.4831Z" />
        <path id="path1_fill" d="M 178.489 74.5219C 182.65 55.9028 183.368 36.7924 180.578 18.1882C 162.815 20.8414 145.567 26.7444 129.598 35.4721C 150.362 43.7848 167.467 57.5651 178.489 74.5219Z" />
        <path id="path2_fill" d="M 3.75724 74.5219C -0.403592 55.9028 -1.12167 36.7924 1.66824 18.1882C 19.4311 20.8414 36.6788 26.7444 52.6484 35.4721C 31.8842 43.7848 14.7786 57.5651 3.75724 74.5219Z" />
      </defs>
    </svg>
  )
}
export default RootsPig;

export function resize(props) {
  const { radius, minY } = props;

  return {
    ...props,
    minY: minY + radius * .3,
  };
}


// WEBPACK FOOTER //
// ./src/core/thematic/rootstech/pig.js